<template>
  <Divider>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Divider>
</template>

<script setup lang="ts">
import type { DividerEmits, DividerProps } from "primevue";

import { Divider } from "primevue";

defineProps</* @vue-ignore */ DividerProps>();
defineEmits</* @vue-ignore */ DividerEmits>();
</script>

<style lang="postcss">
.p-divider {
  &-horizontal {
    @apply relative mx-0 my-4 flex w-full items-center px-4 py-0 before:absolute before:start-0 before:top-1/2 before:block before:w-full before:border-t before:border-slate-200;

    .p-divider-content {
      @apply px-2 py-0;
    }
  }

  &-vertical {
    @apply relative mx-4 my-0 flex min-h-full justify-center px-0 py-2 before:absolute before:start-1/2 before:top-0 before:block before:h-full before:border-s before:border-slate-200;
  }

  &.p-divider-vertical .p-divider-content {
    @apply px-0 py-2;
  }

  &-content {
    @apply z-10 bg-surface-0 text-surface-700;
  }

  &-solid {
    &.p-divider-horizontal::before {
      @apply border-solid;
    }

    &.p-divider-vertical::before {
      @apply border-solid;
    }
  }

  &-dashed {
    &.p-divider-horizontal::before {
      @apply border-dashed;
    }

    &.p-divider-vertical::before {
      @apply border-dashed;
    }
  }

  &-dotted {
    &.p-divider-horizontal::before {
      @apply border-dotted;
    }

    &.p-divider-vertical::before {
      @apply border-dotted;
    }
  }

  &-left:dir(rtl),
  &-right:dir(rtl) {
    @apply flex-row-reverse;
  }
}
</style>
